import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { TextButton } from '../../../../Button/index.js';
import { FlexContainer } from '../../../../CSS/index.js';
export const TruncatedCollapsedView = ({ maxLines, children }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    function handleShowMoreLess() {
        setIsCollapsed(prevIsCollapsed => !prevIsCollapsed);
    }
    return (_jsxs(FlexContainer, { style: {
            flexDirection: 'column',
            gap: 15,
            '& > button': {
                padding: 0
            }
        }, children: [children(isCollapsed
                ? {
                    '&&': {
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitLineClamp: maxLines,
                        WebkitBoxOrient: 'vertical'
                    }
                }
                : {}), _jsx(TextButton, { onClick: handleShowMoreLess, children: isCollapsed ? '+ show more' : '– show less' })] }));
};
//# sourceMappingURL=index.js.map